import { ControllerPaletteColor } from './__palette-color';
import { ControllerTypographyColor } from './typography';

export enum ControllerLinkColor {
  DefaultFg = ControllerPaletteColor.Ngb400,
  MenuFg = ControllerTypographyColor.Default,
}
